
const STANDARD_TO_LEGACY = {
    bo_motor: 'geared_motor',
    servo_180: 'servo_motor', // generic servo == 180
    servo_270: 'servo_motor_270',
    servo_360: 'servo_motor_360',
    servo_sg90: 'servo_motor_sg90',
    digital_input_3pin: 'Digital_3_Pin_Input',
    digital_output_3pin: 'Digital_3_Pin_Output',
    analog_input_3pin: 'Analog_3_Pin_Input',
    analog_output_3pin: 'PWM_3_Pin_Output',
    ultrasonic_sensor_3pin: 'ultrasonic_sensor',
    imu_6axis_4pin: 'IMU',
    color_sensor_4pin: 'Color_sensor',
    magnetometer_3pin: 'Magnetometer',
    // no-change (already standard): dc_motor, mini_geared_motor, dynamex_motor
}


const INTERNAL_STANDARD_TO_LEGACY = {
    toki_ir_sensor: 'ir_sensor',
}


const PORT_STANDARD_TO_LEGACY = {
    S1: 'servo_motor1',
    S2: 'servo_motor2',
}


const ACCESSORY_FIELDS = new Set(['name', 'component'])

const PORT_SUBSTRING_FIELDS = new Set(['uiTarget', 'hardwareKey'])


const _portSubstringRe = new RegExp(
    Object.keys(PORT_STANDARD_TO_LEGACY)
        .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .join('|'),
    'g'
)
const applyPortSubstring = (s) =>
    s.replace(_portSubstringRe, (m) => PORT_STANDARD_TO_LEGACY[m] || m)


const legacyizeInternal = (item) => {
    if (typeof item !== 'string') return item
    const legacy = INTERNAL_STANDARD_TO_LEGACY[item] || item
    return legacy.replace(/_/g, ' ')
}


export function legacyizeAccessoryNames(node) {
    if (Array.isArray(node)) {
        return node.map((n) => legacyizeAccessoryNames(n))
    }
    if (node && typeof node === 'object') {
        const out = {}
        for (const [k, v] of Object.entries(node)) {
            if (ACCESSORY_FIELDS.has(k) && typeof v === 'string' && STANDARD_TO_LEGACY[v]) {
                out[k] = STANDARD_TO_LEGACY[v]
            } else if (k === 'externalAccessories' && Array.isArray(v)) {
                out[k] = v.map((item) =>
                    typeof item === 'string' && STANDARD_TO_LEGACY[item]
                        ? STANDARD_TO_LEGACY[item]
                        : item
                )
            } else if (k === 'internalAccessories' && Array.isArray(v)) {
                out[k] = v.map((item) => legacyizeInternal(item))
            } else if (k === 'port' && typeof v === 'string' && PORT_STANDARD_TO_LEGACY[v]) {
                out[k] = PORT_STANDARD_TO_LEGACY[v]
            } else if (PORT_SUBSTRING_FIELDS.has(k) && typeof v === 'string') {
                out[k] = applyPortSubstring(v)
            } else {
                out[k] = legacyizeAccessoryNames(v)
            }
        }
        return out
    }
    return node
}

export default legacyizeAccessoryNames
